<div class="schedule-navbar">
    <div class="content">
        <p class="large">
            @if (realisation(); as item) {
                {{ item | realisationAfasProjectIdPipe }}
            }
        </p>
        <p class="small">{{ date | date: 'EEEE d MMMM yyyy' }}</p>
    </div>
</div>
<div class="content details">
    @if (realisation(); as item) {
        <app-realisation-detail [realisation]="item" />
    } @else {
        <div class="head section bg-white">
            <div class="container-xl">
                <h1>{{ date >= maxDate ? 'nog niet beschikbaar' : 'niet ingepland' }}</h1>
            </div>
        </div>
    }
</div>
<div class="button-wrapper">
    <div class="container-xl">
        <div class="buttons">
            <button class="planning-button" (click)="back()" mat-raised-button color="primary">Terug</button>

            @if (date < maxDate && (Functionalities.Hours | hasFunctionality)) {
                <button
                    class="planning-button ms-2"
                    mat-raised-button
                    color="accent"
                    routerLink="/hours/{{ date | date: 'yyyy-MM-dd' }}">
                    Urenregistratie
                </button>
            }
        </div>
    </div>
</div>
